import { useEffect } from "react";

export default function VisitorCounter() {
  useEffect(() => {
    const scriptId = "counterapi-script";

    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://counterapi.com/c.js";
    script.async = true;

    document.body.appendChild(script);
  }, []);

  return (
    <div className="flex items-center justify-center gap-2 text-sm text-white/60">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2.06 12.34a1 1 0 0 1 0-.68 10 10 0 0 1 19.88 0 1 1 0 0 1 0 .68 10 10 0 0 1-19.88 0" />
        <circle cx="12" cy="12" r="3" />
      </svg>

      <span>Total Visitors:</span>

      <div
        className="counterapi font-semibold text-white"
        key="total-website-visitors"
        action="view"
        style={{ minHeight: 44 }}
      />
    </div>
  );
}